<template>
<div>
    <van-popup v-model="contShow" round position="bottom" @click-overlay="gbFu()" :style="{ height: '24rem' }">
        <img src="../../../assets/videoImg/top.png" alt="" class="topImg" @click="top" v-if="active==0&&tuluList.length>0" />
        <img src="../../../assets/videoImg/top.png" alt="" class="topImg" @click="top" v-if="active==1&&tuluListOld.length>0" />
        <div class="agreement_box">
            <div class="agreement_title van-ellipsis" @click="clickOne(tulu)">{{tulu.session_name}}</div>
            <div class="agreement_title2 van-ellipsis" @click="clickTwo(tulu)">{{tulu.special_name}}<span v-if="tulu.special_isissue==1&&tulu.session_isissue==1">></span></div>
            <div class="agreement_he">
                <div class="agreement_he_left">本场共计{{tulu.total}}件拍品</div>
                <div v-if="!isVipMember&&havePrice==1" class="memberVip agreement_he_right" @click="gotoVip('会员查看完整价格',5)"></div>
                <!-- <div class="agreement_he_right" v-if="baseList.online_auction_type==1&&liveData.isLogin==1">
                        保证金余额：<span>RMB{{tulu.deposit_amount}}</span>
                    </div> -->
            </div>
            <!-- 这是单独直接列表的 -->
            <div class="cp_box" v-if="statue==1">
                <div class="cp_xuan">
                    <div :class="item.type != '0' ? 'cp_xuan_list cp_xuan_list_active' : 'cp_xuan_list'" v-for="item in xuanData" :key="item.name" @click="xuanFun(item)">
                        {{ item.name }}
                        <div class="cp_xuan_jt">
                            <p class="p11 p11_active" v-if="item.type == '1'"></p>
                            <p class="p11" v-else></p>
                            <p class="p12 p12_active" v-if="item.type == '2'"></p>
                            <p class="p12" v-else></p>
                        </div>
                    </div>
                </div>
                <listmore-component></listmore-component>
            </div>
            <!-- 状态不同样式不同（这是带tab切换的） -->
            <template v-if="baseList.live_type!=3">
                <div class="cp_boxtwo" v-if="statue==2">
                    <van-tabs @click="onClick" animated v-model="active">
                        <van-tab :title="baseList.auction_status==1?'待拍卖':'拍卖中'">
                            <div class="content" ref="content_1">
                                <template v-if="tuluList.length==0">
                                    <div class="none">
                                        <img src="../../../assets/img/none.png" alt="" />
                                        <p>暂无数据</p>
                                    </div>
                                </template>
                                <template v-if="tuluList.length>0">
                                    <van-list center v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                                        <div v-for="(item,index) in tuluList" :key="index" :title="item.title">
                                            <div class="cp_con">
                                                <div class="cp_list">
                                                    <div class="cp_list_tu" @click="ppxq(item)">
                                                        <van-image fit="contain" :src="item.cover_pic" />
                                                    </div>
                                                    <div class="cp_list_con">
                                                        <van-button type="primary" size="mini" class="cp_btn cp_btn_1" v-if="baseList.online_auction_type==1&&item.status==2" @click="chujia(item,chujiadis)">出价</van-button>
                                                        <!-- <van-button type="primary" size="mini" class="cp_btn cp_btn_2" v-if="baseList.online_auction_type==1" @click="chongzhi()">交保证金</van-button> -->
                                                        <div class="cp_list_name van-multi-ellipsis--l2" @click="ppxq(item)">
                                                            <!-- <span class="s1" v-if="baseList.auction_status!=2&&item.status==2">拍卖中</span>
                                                            <span class="s2" v-if="baseList.auction_status!=2&&item.status==1">待拍卖</span>
                                                            <span class="s1" v-if="baseList.auction_status==2&&index==0">拍卖中</span>
                                                            <span class="s2" v-if="baseList.auction_status==2&&index!=0">待拍卖</span> -->
                                                            <span class="s1 sss" v-if="item.status==2">拍卖中</span>
                                                            <span class="s2 sss" v-if="item.status==1">待拍卖</span>
                                                            <span class="sss0">已结拍</span>
                                                            {{item.title}}
                                                        </div>
                                                        <div class="cp_list_conBox">
                                                            <template v-for="(items) in item.extra_info">
                                                                <div class="cp_list_nr cp_list_nr1" :key="items.type" v-if="items.type=='current_price'">
                                                                    <!-- 当前价 -->
                                                                    {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                                </div>
                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='next_price'&&baseList.online_auction_type==1">
                                                                    <!-- 下口价 -->
                                                                    {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                                </div>
                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='gujia'">
                                                                    <!-- 估价 -->
                                                                    {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                                </div>
                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='author'&&item.status==1">
                                                                    <!-- 作者 -->
                                                                    <!-- {{items.label}} -->
                                                                    <span class="ss s12">
                                                                        <span v-for="itemss in items.isSample" :key="itemss.id" style="color:#18bd6f;font-weight:normal;" @click="renFu(itemss)">
                                                                            <!-- <img src="../../../assets/videoImg/ren.png" alt="" style="margin:0px 0.2rem 0px 0.4rem;"/>{{itemss.name}} -->
                                                                            <img src="../../../assets/videoImg/see.png" alt="" style="margin:0px 0.2rem 0px 0rem;" />{{itemss.name}}
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </van-list>
                                </template>
                            </div>
                        </van-tab>
                        <van-tab title="已结拍">
                            <div class="content" ref="content_2">
                                <template v-if="tuluListOld.length==0">
                                    <div class="none">
                                        <img src="../../../assets/img/none.png" alt="" />
                                        <p>暂无数据</p>
                                    </div>
                                </template>
                                <template v-if="tuluListOld.length>0">
                                    <van-list center v-model="loading2" :finished="finished2" finished-text="没有更多了" @load="onLoad2">
                                        <div v-for="(item,index) in tuluListOld" :key="index" :title="item.title">
                                            <div class="cp_con">
                                                <div class="cp_list">
                                                    <div class="cp_list_tu" @click="ppxq(item)">
                                                        <van-image fit="contain" :src="item.cover_pic" />
                                                    </div>
                                                    <div class="cp_list_con">
                                                        <div class="cp_list_name van-multi-ellipsis--l2" @click="ppxq(item)">
                                                            <span class="s3 sss">已结拍</span>
                                                            <span class="sss0">已结拍</span>
                                                            {{item.title}}
                                                        </div>
                                                        <div class="cp_list_conBox">
                                                            <template v-for="(items) in item.extra_info.slice(0,2)">
                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='price'">
                                                                    <!-- 落槌价 -->
                                                                    {{items.label}}

                                                                    <span class="ss s11" v-if="liveData.isLogin==1&&isMem==1">{{items.small_text}}</span><span class="ss s12" v-if="liveData.isLogin==1&&isMem==1">{{items.text}}</span>
                                                                    <!-- <img  @click="dlu" src="@/assets/img/memberview.png" alt="" style="cursor: pointer;width:100px;height:20px;object-fit: contain;" /> -->
                                                                    <span style="color:red;" v-if="liveData.isLogin==0||isMem!=1" @click="dlu">{{items.small_text}}&nbsp;****</span>
                                                                </div>
                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='hammer_price'">
                                                                    <!-- 落槌价 -->
                                                                    <template v-if="isVipMember">
                                                                        <template v-if="items.text == '流拍' || items.text == '撤拍'">
                                                                            {{items.loginText}}
                                                                        </template>
                                                                        <template v-else>
                                                                            {{items.label}}
                                                                            <span class="ss s11">{{items.small_text}}</span>
                                                                            <span class="ss s12">{{items.text}}</span>
                                                                        </template>
                                                                    </template>
                                                                    <template v-else>
                                                                        {{items.label}}
                                                                        <span class="ss s11" @click="dlu">{{items.small_text}}</span>
                                                                        <span @click="dlu" class="ss s12">{{items.nonMemberText}}</span>
                                                                    </template>
                                                                </div>

                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='next_price'&&baseList.online_auction_type==1">
                                                                    <!-- 下口价 -->
                                                                    {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                                </div>
                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='gujia'">
                                                                    <!-- 估价 -->
                                                                    {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                                </div>
                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='author'">
                                                                    <!-- 作者 -->
                                                                    <!-- {{items.label}} -->
                                                                    <span class="ss s12">
                                                                        <span v-for="itemss in items.isSample" :key="itemss.id" style="color:#18bd6f;font-weight:normal;" @click="renFu(itemss)">
                                                                            <!-- <img src="../../../assets/videoImg/ren.png" alt="" style="margin:0px 0.2rem 0px 0.4rem;"/>{{itemss.name}} -->
                                                                            <img src="../../../assets/videoImg/see.png" alt="" style="margin:0px 0.2rem 0px 0rem;" />{{itemss.name}}
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                                <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='not_price'">
                                                                    <!-- 流拍、撤拍 -->
                                                                    {{items.label}}
                                                                    <span class="ss s11" v-if="liveData.isLogin==1">{{items.small_text}}</span><span class="ss s12" v-if="liveData.isLogin==1">{{items.text}}</span>
                                                                    <span style="color:red;" v-if="liveData.isLogin==0" @click="dlu">{{items.loginText}}</span>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </van-list>
                                </template>
                            </div>
                        </van-tab>
                    </van-tabs>
                </div>
            </template>
            <template v-else>
                <div class="content" ref="content_1" v-if="active!=1">
                    <template v-if="tuluList.length==0">
                        <div class="none">
                            <img src="../../../assets/img/none.png" alt="" />
                            <p>暂无数据</p>
                        </div>
                    </template>
                    <template v-if="tuluList.length>0">
                        <van-list center v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                            <div v-for="(item,index) in tuluList" :key="index" :title="item.title">
                                <div class="cp_con">
                                    <div class="cp_list">
                                        <div class="cp_list_tu" @click="ppxq(item)">
                                            <van-image fit="contain" :src="item.cover_pic" />
                                        </div>
                                        <div class="cp_list_con">
                                            <van-button type="primary" size="mini" class="cp_btn cp_btn_1" v-if="baseList.online_auction_type==1&&item.status==2" @click="chujia(item,chujiadis)">出价</van-button>
                                            <!-- <van-button type="primary" size="mini" class="cp_btn cp_btn_2" v-if="baseList.online_auction_type==1" @click="chongzhi()">交保证金</van-button> -->
                                            <div class="cp_list_name van-multi-ellipsis--l2" @click="ppxq(item)">
                                                <!-- <span class="s1" v-if="baseList.auction_status!=2&&item.status==2">拍卖中</span>
                                                            <span class="s2" v-if="baseList.auction_status!=2&&item.status==1">待拍卖</span>
                                                            <span class="s1" v-if="baseList.auction_status==2&&index==0">拍卖中</span>
                                                            <span class="s2" v-if="baseList.auction_status==2&&index!=0">待拍卖</span> -->
                                                <span class="s1 sss" v-if="item.status==2">拍卖中</span>
                                                <span class="s2 sss" v-if="item.status==1">待拍卖</span>
                                                <span class="sss0">已结拍</span>
                                                {{item.title}}
                                            </div>
                                            <div class="cp_list_conBox">
                                                <template v-for="(items) in item.extra_info">
                                                    <div class="cp_list_nr cp_list_nr1" :key="items.type" v-if="items.type=='current_price'">
                                                        <!-- 当前价 -->
                                                        {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                    </div>
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='next_price'&&baseList.online_auction_type==1">
                                                        <!-- 下口价 -->
                                                        {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                    </div>
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='gujia'">
                                                        <!-- 估价 -->
                                                        {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                    </div>
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='author'&&item.status==1">
                                                        <!-- 作者 -->
                                                        <!-- {{items.label}} -->
                                                        <span class="ss s12">
                                                            <span v-for="itemss in items.isSample" :key="itemss.id" style="color:#18bd6f;font-weight:normal;" @click="renFu(itemss)">
                                                                <!-- <img src="../../../assets/videoImg/ren.png" alt="" style="margin:0px 0.2rem 0px 0.4rem;"/>{{itemss.name}} -->
                                                                <img src="../../../assets/videoImg/see.png" alt="" style="margin:0px 0.2rem 0px 0rem;" />{{itemss.name}}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </template>
                </div>
                <div class="content" ref="content_2" v-else>
                    <template v-if="tuluListOld.length==0">
                        <div class="none">
                            <img src="../../../assets/img/none.png" alt="" />
                            <p>暂无数据</p>
                        </div>
                    </template>
                    <template v-if="tuluListOld.length>0">
                        <van-list center v-model="loading2" :finished="finished2" finished-text="没有更多了" @load="onLoad2">
                            <div v-for="(item,index) in tuluListOld" :key="index" :title="item.title">
                                <div class="cp_con">
                                    <div class="cp_list">
                                        <div class="cp_list_tu" @click="ppxq(item)">
                                            <van-image fit="contain" :src="item.cover_pic" />
                                        </div>
                                        <div class="cp_list_con">
                                            <div class="cp_list_name van-multi-ellipsis--l2" @click="ppxq(item)">
                                                <span class="s3 sss">已结拍</span>
                                                <span class="sss0">已结拍</span>
                                                {{item.title}}
                                            </div>
                                            <div class="cp_list_conBox">
                                                <template v-for="(items) in item.extra_info.slice(0,2)">
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='price'">
                                                        <!-- 落槌价 -->
                                                        {{items.label}}
                                                        <span class="ss s11" v-if="liveData.isLogin==1&&isMem==1">{{items.small_text}}</span><span class="ss s12" v-if="liveData.isLogin==1&&isMem==1">{{items.text}}</span>
                                                        <!-- <img  @click="dlu" src="@/assets/img/memberview.png" alt="" style="cursor: pointer;width:100px;height:20px;object-fit: contain;" /> -->
                                                        <span style="color:red;" v-if="liveData.isLogin==0||isMem!=1" @click="dlu">{{items.small_text}}&nbsp;****</span>
                                                    </div>
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='hammer_price'">
                                                        <!-- 落槌价 -->
                                                        {{items.label}}
                                                        <span class="ss s11" @click="dlu">{{items.small_text}}</span><span @click="dlu" class="ss s12">{{items.text}}</span>
                                                    </div>
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='next_price'&&baseList.online_auction_type==1">
                                                        <!-- 下口价 -->
                                                        {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                    </div>
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='gujia'">
                                                        <!-- 估价 -->
                                                        {{items.label}}<span class="ss s11">{{items.small_text}}</span><span class="ss s12">{{items.text}}</span>
                                                    </div>
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='author'">
                                                        <!-- 作者 -->
                                                        <!-- {{items.label}} -->
                                                        <span class="ss s12">
                                                            <span v-for="itemss in items.isSample" :key="itemss.id" style="color:#18bd6f;font-weight:normal;" @click="renFu(itemss)">
                                                                <!-- <img src="../../../assets/videoImg/ren.png" alt="" style="margin:0px 0.2rem 0px 0.4rem;"/>{{itemss.name}} -->
                                                                <img src="../../../assets/videoImg/see.png" alt="" style="margin:0px 0.2rem 0px 0rem;" />{{itemss.name}}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div class="cp_list_nr cp_list_nr3" :key="items.type" v-if="items.type=='not_price'">
                                                        <!-- 流拍、撤拍 -->
                                                        {{items.label}}
                                                        <span class="ss s11" v-if="liveData.isLogin==1">{{items.small_text}}</span><span class="ss s12" v-if="liveData.isLogin==1">{{items.text}}</span>
                                                        <span style="color:red;" v-if="liveData.isLogin==0" @click="dlu">{{items.loginText}}</span>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </template>
                </div>

            </template>
        </div>
    </van-popup>
</div>
</template>

<script>
import {
    scMdFunc
} from "@/assets/js/scData";
import {
    getApp
} from '@/api/auction'
export default {
    props: ["moreListShow", "liveData", "tulu", "tuluList", "tuluListOld", "chujiadis", "yhxx", "isMem", "isVipMember", "havePrice"],
    data() {
        return {
            statue: 2, //状态决定是tab还是直接列表
            contShow: this.moreListShow, //显示
            xuanData: [{
                    name: "Lot 号",
                    type: "0"
                },
                {
                    name: "起拍价",
                    type: "0"
                },
            ],
            baseList: '', //基础
            company_data: '', //拍卖机构信息
            loading: false,
            finished: false,
            shu: 10,
            loading2: false,
            finished2: false,
            shu2: 10,
            active: 0,
            shuTop: 0,
            t: '',
            platform: null,
            isTuluApp: false,

        };
    },
    components: {},
    created: function () {
        this.getApp()
    },
    mounted() {
        this.t = Date.now()
        this.isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
    },
    methods: {
        onLoad() { //拍卖中--加载更多
            this.$parent.getLiveAuctionList(this.company_data, 1, 0, this.tuluList[this.tuluList.length - 1].lot); //直播间拍品列表--拍卖中
        },
        onLoadzt(loading, finished) { //拍卖中--加载更多状态
            this.loading = loading;
            this.finished = finished;
        },
        onLoad2() { //已结拍--加载更多
            this.$parent.getLiveAuctionList(this.company_data, 2, 0, this.tuluListOld[this.tuluListOld.length - 1].lot); //直播间拍品列表--已结拍
        },
        onLoadzt2(loading, finished) { //已结拍--加载更多状态
            this.loading2 = loading;
            this.finished2 = finished;
        },
        gbFu() { //关闭
            this.$parent.focusXian(0);
        },
        clickOne(tulu) { //跳转拍卖会
            let bridge = window.WebViewJavascriptBridge;
            if (tulu.special_isissue == 1 && tulu.session_isissue == 1) { //有预展
                if (this.isTuluApp) {
                    bridge.callHandler('appSessionDetail', {
                        sessionCode: tulu.session_code
                    }, function () {})
                } else {
                    window.location.href = 'https://m-auction.artron.net/session/' + tulu.session_code + '?fromlink=' + encodeURIComponent(window.location.href);
                }

            }
        },
        clickTwo(tulu) { //跳转拍卖专场
            let bridge = window.WebViewJavascriptBridge;
            if (tulu.special_isissue == 1 && tulu.session_isissue == 1) { //有预展
                if (this.isTuluApp) {
                    bridge.callHandler('appSecLink', {
                        secLink: tulu.special_code
                    }, function () {})
                } else {
                    window.location.href = 'https://m-auction.artron.net/special/' + tulu.special_code + '?fromlink=' + encodeURIComponent(window.location.href);
                }
            }
        },
        xuanFun(row) {
            //点击正序倒序排序
            if (row.type == "0" || row.type == "2") {
                row.type = "1";
            } else if (row.type == "1") {
                row.type = "2";
            }
        },
        moreListFun(show, liveData, status) {
            let that = this;
            this.contShow = show;
            this.active = status - 1;
            this.baseList = liveData.baseList;
            this.company_data = liveData.company_data;
            setTimeout(function () {
                that.$refs.content_1.scrollTop = 0
                that.$refs.content_2.scrollTop = 0
            }, 300)

        },
        // 状态下的拍卖中和已结拍点击
        onClick(name, title) {
            console.log(name, title);
            if (title == "拍卖中") {
                this.active = 0;
            } else if (title == "已结拍") {
                this.active = 1;
            }
        },
        // 跳转拍品详情
        ppxq(data) {
            
            let bridge = window.WebViewJavascriptBridge;
            if (this.isTuluApp) {
                bridge.callHandler('appArtDetail', {
                    artCode: data.artcode
                }, function () {})
            } else {
                if (this.$route.query.from == '2') { //有水印
                    //this.$router.push({path: '/auction',query:{ liveid:Number(this.$route.query.id),art_id:data.art_id,from:'2'}});
                    this.$router.push(`auction/${this.$route.query.id}/${data.art_id}/${this.$route.query.special_id}` + '?from=2&btnShow=1')
                } else { //无水印
                    //this.$router.push({path: '/auction',query:{ liveid:Number(this.$route.query.id),art_id:data.art_id}});
                    this.$router.push(`auction/${this.$route.query.id}/${data.art_id}/${this.$route.query.special_id}` + '?btnShow=1')
                }
            }

        },
        // 跳转作者详情
        renFu(data) {
            if (data.id > 0) {
                if (this.$route.query.from == '2') { //有水印
                    window.location.href = 'http://tulu.artron.net/mark/index/' + data.id + '?from=2'
                } else { //无水印
                    window.location.href = 'http://tulu.artron.net/mark/index/' + data.id
                }
            }
        },
        // 出价
        chujia(row, chujiadis) {
            var liveid = this.$route.query.id //直播id
            var special_id = this.$route.query.special_id //专场id
            var uid = this.yhxx.imRoles && this.yhxx.imRoles.length > 0 ? this.yhxx.imRoles[0].uid : this.yhxx.defaultRoles.uid //用户id
            var agreementChecked = sessionStorage.getItem('agreementChecked');
            var agreementCheckedArr = [];
            if (agreementChecked != '' && agreementChecked != null && agreementChecked != undefined) {
                agreementCheckedArr = agreementChecked.split("、");
            }
            if (this.liveData.isLogin == 0) {
                this.$parent.noLogin()
            } else if (this.liveData.isLogin == 1) {
                let i = 0;
                agreementCheckedArr.forEach(item => {
                    if (item == liveid + '-' + special_id + '-' + uid) {
                        if (chujiadis == true) { //自由出价
                            this.$parent.offerOver('2', row);
                        } else { //下口价出价
                            this.$parent.offerOver('1', row);
                        }
                    } else {
                        i++
                    }
                });
                if (i == agreementCheckedArr.length) {
                    this.$parent.agreementOverFu(true);
                }
            }

            /* var agreementChecked=sessionStorage.getItem('agreementChecked');
            if(this.liveData.isLogin==0){
                this.$parent.noLogin()
            }else if(this.liveData.isLogin==1){
                if(agreementChecked=='true'){//已同意协议
                    if(chujiadis==true){//自由出价
                        this.$parent.offerOver('2',item);
                    }else{//下口价出价
                        this.$parent.offerOver('1',item);
                    }
                }else{//未同意协议
                    this.$parent.agreementOverFu(true);
                }
            } */
        },
        // 充值（交保证金）
        chongzhi() {
            if (this.liveData.isLogin == 0) {
                this.$parent.noLogin()
            } else if (this.liveData.isLogin == 1) {
                window.location.href = this.baseList.deposit_url;
            }
        },
        top() {
            var div = ''
            if (this.active == 0) {
                div = this.$refs.content_1
            } else if (this.active == 1) {
                div = this.$refs.content_2
            }
            this.shuTop = div.scrollTop / 100
            this.dingFun(div, div.scrollTop)
        },
        dingFun(div, shu) { //回到顶部方法
            var _this = this;
            if (shu > 0) {
                setTimeout(function () {
                    shu = shu - _this.shuTop
                    div.scrollTop = shu
                    _this.dingFun(div, shu);
                }, 1)
            }
        },
        gotoLogin() {

        },
        getApp() {
            getApp().then((res) => {
                this.platform = res.data.data
            })
        },
        //未登录
        dlu() {
            if (this.liveData.isLogin == 0) {
                if (this.platform.isApp) {
                    let bridge = window.WebViewJavascriptBridge
                    bridge.callHandler('appOpenLogin', {
                        url: window.location.href
                    }, function (response) {});
                } else {
                    window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
                }
            }
        },
        gotoVip(text, num) {
            let obj = {}
            if (this.liveData.isLogin == 0) {
                this.dlu();
            } else {
                if (!this.isVipMember) {
                    let bridge = window.WebViewJavascriptBridge;
                    if (this.platform.isToutiao) {
                        if (this.platform.version >= 464000) {
                            bridge.callHandler('appGotoRightsMembers', {
                                index: 0,
                                source_page: '拍品详情页',
                                source_module: text
                            }, function () {})
                        } else {
                            bridge.callHandler('appGotoRightsMembers', {
                                index: 0
                            }, function () {})
                        }
                    } else if (this.platform.isTulu) {
                        if (this.platform.version >= 1061203) {
                            bridge.callHandler('appOpenMemberPay', {
                                source_page: '拍品详情页',
                                source_module: text
                            }, function () {})
                        } else {
                            bridge.callHandler('appOpenMemberPay', obj, function () {})
                        }
                    } else {
                        window.location.href = 'http://tulu.artron.net/wap/share/member' + "?from=" + encodeURIComponent(location.href);
                        //window.location.href='https://member.artronvip.com/wap/share/member?source_page=7&source_module='+num+'&sourceReferer='+encodeURIComponent(window.location.href)
                    }
                }
            }
            scMdFunc('clickVip', {
                current_page: '直播详情页',
                button_name: '/会员查看完整价格'
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.agreement_box {
    width: 100%;
    height: auto;
    padding: 0.6rem 0.6rem 0rem;
}

.agreement_title {
    width: 100%;
    line-height: 1.1rem;
    font-size: 0.8rem;
    color: #27282d;
    text-align: left;
    font-weight: bold;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
}

.agreement_title2 {
    width: 100%;
    line-height: 1rem;
    font-size: 0.6rem;
    color: #27282d;
    margin-bottom: 0.2rem;
    padding-bottom: 0.2rem;
    border-bottom: 1px solid #f7f7f7;
}

.agreement_he {
    width: 100%;
    overflow: hidden;
    line-height: 1.5rem;
}

.agreement_he_left {
    float: left;
    color: #27282d;
    font-size: 0.8rem;
}

.agreement_he_right {
    float: right;
    color: #27282d;
    font-size: 0.6rem;
}

.agreement_he_right span {
    color: #ff3b30;
    font-weight: bold;
}

.cp_boxtwo {
    margin-top: 0.5rem;
}

.cp_xuan {
    width: 100%;
    line-height: 1.2rem;
    margin: 0.4rem 0rem;
    overflow: hidden;
}

.cp_xuan_list {
    float: left;
    font-size: 0.7rem;
    color: #27282d;
    margin-right: 2rem;
}

.cp_xuan_list_active {
    color: #18bd6f;
}

.cp_xuan_jt {
    width: 0.8rem;
    float: right;
    padding-top: 0.25rem;
    padding-left: 0.2rem;
}

.cp_xuan_jt .p11 {
    width: 0;
    height: 0;
    border-left: 0.2rem solid transparent;
    border-right: 0.2rem solid transparent;
    border-bottom: 0.3rem solid #656565;
    margin-bottom: 0.1rem;
}

.cp_xuan_jt .p11_active {
    border-bottom: 0.3rem solid #18bd6f;
}

.cp_xuan_jt .p12 {
    width: 0;
    height: 0;
    border-left: 0.2rem solid transparent;
    border-right: 0.2rem solid transparent;
    border-top: 0.3rem solid #656565;
}

.cp_xuan_jt .p12_active {
    border-top: 0.3rem solid #18bd6f;
}

// tab样式
/deep/ .van-tabs__wrap {
    border-radius: 0.25rem;
}

/deep/ .van-tab {
    background-color: #ececec;
}

/deep/ .van-tabs__nav {
    background-color: #ececec;
}

/deep/ .van-tab--active {
    border: none;
    background-color: #ffffff;
    border: 0.1rem solid #ECECEC;
    border-radius: 0.25rem;
}

/deep/ .van-tabs__line {
    display: none;
}

// 滚动
.content {
    width: 100%;
    height: 15.8rem;
    overflow-x: scroll;
    overflow-y: scroll;
    position: relative;
}

.topImg {
    width: 3rem;
    position: fixed;
    right: 0.6rem;
    bottom: 0.6rem;
    z-index: 99999;
    cursor: pointer;
}

.outer-container {
    width: 100%;
    position: relative;
    overflow: hidden;
    padding-top: 0.5rem;
    padding-bottom: 0.6rem;
}

// 解决滚动有部分隐藏了
/deep/ .van-list__finished-text {
    padding-bottom: 0.5rem;
}

/deep/ .van-list__loading {
    padding-bottom: 0.5rem;
}

.cp_box {
    width: 100%;
}

.cp_con {
    width: 100%;
    max-height: 15rem;
    border-top: 1px solid #f7f7f7;
}

.cp_list {
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0.4rem 0rem;
    position: relative;
}

.cp_list_tu {
    width: 22%;
    height: 5rem;
    float: left;
    border-radius: 0.25rem;
    overflow: hidden;
    background: #eee;
}

.cp_list_tu img {
    width: 100%;
    height: auto;
}

.cp_list_con {
    width: 75%;
    height: 5rem;
    float: right;
    position: relative;
}

.cp_list_conBox {
    width: 100%;
    height: auto;
    position: absolute;
    bottom: 0px;
    left: 0px;
}

.cp_btn {
    position: absolute;
    right: 0px;
    border-radius: 0.6rem;
    padding: 0.2rem 0.5rem;
    margin-right: 0.4rem;
    z-index: 999;
}

.cp_btn_1 {
    background: #18BD6F;
    bottom: 0.2rem;
}

.cp_btn_2 {
    background: #FF5D4F;
    border: 1px solid #FF5D4F;
    top: 2.8rem;
}

.cp_list_name {
    width: 100%;
    line-height: 1.1rem;
    font-size: 0.8rem;
    color: #27282d;
    margin: 0.2rem 0rem;
    overflow: hidden;
    position: relative;
}

.cp_list_name .sss0 {
    display: inline-block;
    padding: 0rem 0.2rem;
    font-size: 0.5rem;
    border-radius: 0.1rem;
    color: #fff;
    line-height: 0.8rem;
}

.cp_list_name .sss {
    display: inline-block;
    padding: 0rem 0.2rem;
    font-size: 0.5rem;
    border-radius: 0.1rem;
    color: #fff;
    line-height: 0.8rem;
    position: absolute;
    top: 0.15rem;
    left: 0rem;
}

.cp_list_name .s1 {
    background: #e35458;
}

.cp_list_name .s2 {
    background: #18bd6f;
}

.cp_list_name .s3 {
    background: #656565;
}

.cp_list_nr {
    width: 100%;
    line-height: 1rem;
    font-size: 0.7rem;
    color: #969696;
    margin: 0.1rem 0rem;
}

.cp_list_nr img {
    width: 0.8rem;
}

.cp_list_nr .s11 {
    font-size: 0.5rem;
}

.cp_list_nr .ss {
    font-weight: bold;
}

.cp_list_nr .s11 {
    margin: 0px 0.2rem 0px 0.3rem;
}

.cp_list_nr1 .ss {
    color: #ff3b30;
}

.cp_list_nr2 .ss {
    color: #969696;
}

.cp_list_nr3 .ss {
    color: #27282d;
}

.cp_list_nr4 .ss {
    color: #18bd6f;
}

.van-image {
    width: 100%;
    height: 100%;
}

.memberVip {
    background: url("../../../assets/img/icon_list_vip.png") no-repeat center center;
    background-size: 100% 1.1rem;
    width: 6.7rem;
    height: 1.5rem;
    display: inline-block;
    vertical-align: middle;
}
</style>
